import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-leaves-report',
  templateUrl: './leaves-report.component.html',
  styleUrls: ['./leaves-report.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LeavesReportComponent implements OnInit {

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0
  };
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Actions", prop: "actions" },
  ];
  user_role:any

  task_leave_model={
    title:'',
    body:'',
    label:'643e81d959b78b65557d749e',
    to :'',
    from_date:'',
    to_date:'',
    knowledge_transafer:'',
    status:'643e869259b78b65557d755a'
  }
  task_label_catId = '643e7f6f59b78b65557d744a'

  taskLabelList=[]
  selectedTaskLabel=null
  task_id:any
  emp_list=[]
  selected_emp=null
  statusList =[]
  emp_status_id:any
  status_list=[]
  min_date :any
  max_date :any
  from_date = new FormControl()
  to_date = new FormControl()
  title = new FormControl()
  knowledge_transafer = new FormControl()
  fromDate:any
  toDate:any  
  request_info:any
  reply_info:any
  isReply :boolean =false
  searchVal=''
  @ViewChild('name') inputName
  empFull_list=[]
  selected_empFull=null
  guideline_data:any
  k_transfer:any
  pageNumberSubscription : Subscription

  constructor( private apiService: ApiService,public toastr: ToastrService,
               private modalService: NgbModal,private spinner: NgxSpinnerService,
               private route: ActivatedRoute, private router: Router,
               private store: Store<AppState>
                ) {
                  this.route.queryParamMap.subscribe((params) => {
                    let page = +params.get('page');
                    this.setPage(page)
                  });
                  this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                  .subscribe(pageNumber => {
                    this.page.pageNumber = pageNumber;
                    if(pageNumber !==undefined){
                      this.page.pageNumber = pageNumber -1
                    }
                    if(pageNumber === 0) this.page.pageNumber = 0
                    
                  });
                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Leave Report')
                this.guideline_data = key_data[0]?._id
                this.getEmployeeStatusList()
   }

  ngOnInit(): void {

    
    var today_date = new Date()
    today_date.setDate(today_date.getMonth() -1);
    this.min_date = today_date.toISOString().split('T')[0];

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() +3);
    this.max_date = maxDate.toISOString().split('T')[0];

    this.task_leave_model.from_date = this.min_date
    this.task_leave_model.to_date = this.min_date

    this.from_date.valueChanges.subscribe((value) => {
      this.task_leave_model.from_date = moment(value).format('L')
    })
    this.to_date.valueChanges.subscribe((value) => {
      this.task_leave_model.to_date =  moment(value).format('L')

    })
    this.title.valueChanges.subscribe((value) => {
      this.task_leave_model.title = value
    })
    this.knowledge_transafer.valueChanges.subscribe((value) => {
      this.task_leave_model.knowledge_transafer = value
    })
    let fromDate = new Date()
    fromDate.setFullYear(fromDate.getFullYear() - 1);
    this.fromDate = fromDate.toISOString().split('T')[0];
    this.fromDate = moment(this.fromDate).format('YYYY-MM-DD')
    this.toDate = new Date()
    this.toDate = moment(this.toDate).format('YYYY-MM-DD')
    
    this.getTaskStatusList()
    this.getLeaveList(this.fromDate,this.toDate)
    this.getTaskLabelList()
    this.checkEmpAttendence('all')

  }
  getStartDate(event){
    this.fromDate = event.target.value
    if(this.fromDate > this.toDate){
      this.toastr.error('invalid date!')
    }
    else{
      if(this.fromDate && this.toDate){
        this.getLeaveList(this.fromDate,this.toDate)
      }
    }
  }
  getEndDate(event){
    this.toDate = event.target.value
    if(this.fromDate > this.toDate){
      this.toastr.error('invalid date!')
    }
    else{
      if(this.fromDate && this.toDate){
        this.getLeaveList(this.fromDate,this.toDate)
      }
    }
  }
  getLeaveList(fromDate,toDate){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
   
      this.apiService.getTaskByLabelId('643e81d959b78b65557d749e',this.page.pageNumber+1,this.page.pageSize,fromDate,toDate).subscribe((res:any)=>{
        this.spinner.hide()
        this.rows=res?.data?.items
        this.page.totalPages = res?.data?.totalCount
        res?.data?.items.forEach((item, index) => {
          const regex = /From :- (\d{2}\/\d{2}\/\d{4})\s+To :- (\d{2}\/\d{2}\/\d{4})/;
          const regex2 = /Project Transferred To :- (.+?)\n/;
          const match = item.body.match(regex);
          const match2 = item.body.match(regex2);
          
          if (match && match.length === 3 && match2 ) {
            this.rows[index] = {
              ...item,
              from: match[1],
              to_date: match[2],
              transferred_to: match2[1]? match2[1] : null,
            };
          }
          
        });
      })   
  }
  getTaskStatusList(){
    this.apiService.getTagByTagCatgoryId('643e806559b78b65557d7456').subscribe((res:any)=>{
      this.status_list = res?.data
    })
  }
  getTaskLabelList() {
    this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
      this.taskLabelList = res.data
    })
  }
  getChangeTaskLabelId(event) {
    this.selectedTaskLabel
  }
  getEmployeeStatusList() {
    this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
      this.statusList = res?.data
      let status = this.statusList.find((item) => item.name == 'full_time');
      this.emp_status_id = status._id
      this.getAllEmpList( this.emp_status_id)
    })
  }
  getAllEmpList(status_id) {
    this.apiService.getEmployeeListByStatus(status_id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
      this.emp_list = res?.items
      
    })
  }
  getUserId(event){
    this.selected_emp
  }
  getTaskById(id){
    this.apiService.getTaskById(id).subscribe((res:any)=>{
      this.task_leave_model.body = res?.data[0]?.body
      this.task_leave_model.title = res?.data[0]?.title
      this.task_leave_model.label = res?.data[0]?.label?._id
      this.selected_emp = res?.data[0]?.to[0]?._id
      this.task_leave_model.to = this.selected_emp
    })
  }
  openModalLeave(content,id,data){

    if(id && data){
      this.task_id = id
      this.task_leave_model.body = data.body
      this.task_leave_model.title = data.title
      this.task_leave_model.from_date = data.from
      this.task_leave_model.to_date = data.to
      this.task_leave_model.knowledge_transafer = data.transferred_to
      this.selected_emp = data?.user[0]?._id
      this.k_transfer= this.empFull_list.filter((item) => item.userName === data.transferred_to)
       this.selected_empFull = this.k_transfer[0].userId
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.selected_empFull = null
      this.selected_emp = null
      this.task_id =''

      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.selected_empFull = null
      this.selected_emp = null
      this.task_id =''
    });
  }
  submit(){
    
    if(!this.task_id){
      this.apiService.createTask(this.task_leave_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('leave added successfull!')
          this.modalService.dismissAll()
          this.getLeaveList(this.fromDate,this.toDate)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.task_id){
      this.task_leave_model.to = this.selected_empFull
      this.apiService.updateTask(this.task_id,this.task_leave_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('leave updated successfull!')
          this.modalService.dismissAll()
          this.getLeaveList(this.fromDate,this.toDate)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
   
  }
  deleteTask(id) {
    this.apiService.taskDelete(id).subscribe((res: any) => {
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getLeaveList(this.fromDate,this.toDate)
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }

   // ================== Delete Alert ========================
   confirmDelete(id: any) {
    this.task_id = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
    }).then((result) => {
      if (result.value) {
        this.deleteTask( this.task_id)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe ',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  updateStatus(task_id,status_id){
    let body={
      status : status_id
    }
    this.apiService.updateTask(task_id,body).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.toastr.success('status updated successfull!')
        this.modalService.dismissAll()
        this.getLeaveList(this.fromDate,this.toDate)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  updateBody() {
    this.task_leave_model.body = `Hi,
    Please approve my leave request, details are mentioned below:
    From :- ${this.task_leave_model.from_date}
    To :- ${this.task_leave_model.to_date}

    Reason :- ${this.task_leave_model.title}

    Project Transferred To :- ${this.task_leave_model.knowledge_transafer}

    Let me know if I missed any point.
    I HERE BY CONFIRMED THAT SAME IS NOTIFIED TO CLIENT OR RESOURCE TO WHOM PROJECT IS TRANSFERRED. I WILL FURTHER UPDATE TO CLIENT / SENIOR BY REQUESTED MODE WHILE I WILL NOT AVAILABLE IN THE OFFICE PREMISES.
    
    Thanks,
    Regards,
    ${this.user_role.name}`;
  }
  openModalView(content,data,prop){
    if(prop == 'body'){
      this.request_info = data
    }
    if(prop == 'admin_notes'){
      this.isReply =true
      this.task_id = data._id
      this.reply_info = data.admin_notes
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.request_info =''
      this.isReply =false
      this.task_id=''
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  filterTask(data){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.taskSearchBy(data).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows=res?.data?.items
      this.page.totalPages = res?.data?.totalCount

    })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.getLeaveList(this.fromDate,this.toDate)
  }
  checkEmpAttendence(data){
    this.apiService.checkEmpAttendance(data).subscribe((res:any)=>{
      this.empFull_list = res?.data?.items
    })
  }
  getEmpId(event){
    this.selected_empFull
    this.task_leave_model.knowledge_transafer = event.userName
    this.updateBody()
  }
  getEmpIdd(event){
    this.selected_emp
    this.task_leave_model.to = this.selected_emp
  }
  updateNotes(){
    let body={
      admin_notes: this.reply_info
    }
    this.apiService.updateTask(this.task_id,body).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.toastr.success('updated successfull!')
        this.modalService.dismissAll()
        this.getLeaveList(this.fromDate,this.toDate)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  pageChangeData(page:any){
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
   
      this.apiService.getTaskByLabelId('643e81d959b78b65557d749e',page.offset +1,this.page.pageSize,this.fromDate,this.toDate).subscribe((res:any)=>{
        this.spinner.hide()
        this.setPage(page.offset +1)
        this.rows=res?.data?.items
        this.page.totalPages = res?.data?.totalCount
        res?.data?.items.forEach((item, index) => {
          const regex = /From :- (\d{2}\/\d{2}\/\d{4})\s+To :- (\d{2}\/\d{2}\/\d{4})/;
          const regex2 = /Project Transferred To :- (.+?)\n/;
          const match = item.body.match(regex);
          const match2 = item.body.match(regex2);
          
          if (match && match.length === 3 && match2 ) {
            this.rows[index] = {
              ...item,
              from: match[1],
              to_date: match[2],
              transferred_to: match2[1]? match2[1] : null,
            };
          }
          
        });
      })  
    // this.apiService.getTagsList(page.offset +1,page.pageSize).subscribe((res:any)=>{
    //   this.setPage(page.offset +1)
    //   this.rows=res.data.items
    //   this.page.totalPages=res.data.totalCount
  
    // })
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
}
